import { Mixins, Component, Prop, Ref } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import Proof from '@/views/Authentication/models/proof'

type ClaimItem = {
    info: string // full claim string, e.g email:john@example
    type: string // claim type, e.g email, mobile
    value: string // claim value, e.g john@example
}

@Component({
    inheritAttrs: false,
    name: 'Verify',
    components: { DialogTemplate },
})
export default class Verify extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any
    @Ref('form') readonly form!: HTMLFormElement

    get type() {
        return this.props.type || 'verify'
    }

    get claims(): ClaimItem[] {
        // claim is multi-value MFA-Proof-Claim header, separated by comma
        return this.props.claim.split(/,\s*/).map((claim) => {
            let [type, value] = claim.split(':')
            return {
                info: claim,
                type,
                value,
            }
        })
    }

    get claim() {
        return this.claims[this.claimIndex]
    }

    get secondary() {
        return this.claim.type == 'email' && this.$store.getters.existOnOtherUserEmailVerification
    }

    valid = false
    loading = false
    proof: Proof | null = null
    secret = ''
    retryAfter = 0
    challengeRateLimited = false
    timerInterval: Maybe<number> = null
    claimIndex = 0

    clearTimerInterval() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval)
            this.retryAfter = 0
        }
    }

    sendVerificationCode(claimIndex: number) {
        this.claimIndex = claimIndex
        this.clearTimerInterval()
        this.initiateProof()
    }

    async initiateProof() {
        try {
            this.loading = true
            this.proof = await Proof.initiateProof(this.claim.info, this.userLanguage)
            if (this.proof) {
                this.challengeRateLimited = false
                this.retryAfter = this.proof.retryAfter
                this.form.reset()
            }
        } catch (e) {
            if (e instanceof Object && e['code'] == 'challengeRateLimited') {
                this.retryAfter = e['retryAfter']
                this.challengeRateLimited = true
            }
        } finally {
            this.loading = false
            this.timerInterval = setInterval(() => {
                this.retryAfter--
                if (this.retryAfter < 1) {
                    this.clearTimerInterval()
                }
            }, 1000)
        }

        this.$nextTick(() => {
            this.form?.$children[0]?.focus()
        })
    }

    resetForm() {
        if (this.proof) {
            this.proof.invalidSecret = false
        }
    }

    loadingSubmit = false
    async submit() {
        if (this.proof && this.secret) {
            this.loadingSubmit = true
            try {
                let res = await this.proof.completeProof(this.secret)
                if (res) this.$emit('close', res)
            } catch (error) {
                this.proof.invalidSecret = true
                this.secret = ''
            } finally {
                this.loadingSubmit = false
            }
        }
        this.$nextTick(() => {
            this.form?.$children[0]?.focus()
        })
    }

    created() {
        this.initiateProof()
    }

    beforeDestroy() {
        this.clearTimerInterval()
    }
}
